"use client";

import { PricingApiContext, useProgramMeta } from "@2u-landing-pages/providers";
import { Banner } from "@2u-landing-pages/templates/Banner";
import { TypeBannerWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import React, { useContext } from "react";
import { AutomatedContentBannerProps } from "./AutomatedContent.types";
import { getContentToDisplay } from "./displayContent";
import { StartDatePreview } from "./StartDatePreview";

export const AutomatedContentBanner: React.FC<AutomatedContentBannerProps> = (props) => {
  const programMeta = useProgramMeta();
  const { pricingApiValues } = useContext(PricingApiContext);
  const { id, location, className, start_date_source, start_date_preview, phoneNumber, stripFocusContext } = props;

  const inspector = useContentfulInspectorMode();
  const programMetaStartDate = props.metaStartDate ?? programMeta?.fields?.start_date;
  const pricingApiStartDate = props.pricingApiStartDate ?? pricingApiValues?.startDate;

  const content = getContentToDisplay({
    ...props,
    metaStartDate: programMetaStartDate,
    pricingApiStartDate,
  });

  if (!content) return null;

  const styles = Array.isArray(className) ? className.join(" ") : className;

  return (
    <>
      <Banner
        {...(content.fields as TypeBannerWithoutUnresolvableLinksResponse["fields"])}
        id={id}
        className={styles}
        inspector={inspector}
        location={location}
        phoneNumber={phoneNumber}
        stripFocusContext={stripFocusContext}
      />
      {start_date_source && start_date_preview === "True" && (
        <StartDatePreview
          start_date_source={start_date_source}
          metaStartDate={programMetaStartDate}
          pricingApiStartDate={pricingApiStartDate}
          contentType="banner"
        />
      )}
    </>
  );
};
